import { useLang } from "@/lib/lang";
import { Reveal, Eyebrow } from "./Reveal";

export const Audience = () => {
  const { t } = useLang();
  const a = t.audience;
  return (
    <section id="audienta" className="section" data-testid="audience-section">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>{a.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="h2 mt-6">{a.title} <span className="font-serif font-normal italic text-zinc-400">{a.body}</span></h2>
          </Reveal>
          <Reveal delay={0.1}><p className="mt-8 max-w-xl border-l-2 border-gold pl-5 text-lg text-ink" data-testid="audience-test">{a.test}</p></Reveal>
        </div>
        <div className="flex flex-col justify-end gap-3 lg:col-span-5">
          {a.points.map((p, i) => (
            <Reveal key={p} delay={i * 0.08} className="flex items-center gap-5 rounded-2xl border border-line bg-surface px-6 py-5 transition-colors duration-300 hover:border-gold/50">
              <span className="font-mono text-sm text-gold">0{i + 1}</span>
              <span className="text-ink" data-testid={`audience-point-${i}`}>{p}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
